import { createReducer, on } from '@ngrx/store';
import { loadProjekteStart, loadProjekteFailed, loadProjekteSucceeded } from '../actions/getAllProjekte.actions';
import { ProjektItem } from '../../projekt.model';
import {addProjektFailed, addProjektStart, addProjektSucceeded} from '../actions/projekt-add.actions';
import {deleteProjektFailed, deleteProjektStart, deleteProjektSucceeded} from '../actions/projekt-del.actions';
import {editProjektFailed, editProjektStart, editProjektSucceeded} from '../actions/projekt-edit.actions';
import {getFilteredProjektFailed, getFilteredProjektStart, getFilteredProjektSucceeded} from '../actions/getFilteredProjekt.actions';
import {loadNodesFailed, loadNodesStart, loadNodesSucceeded} from '../actions/getAllNodes.actions';
import {NodeItem} from '../../node.model';
import {addProjektstufeFailed, addProjektstufeStart, addProjektstufeSucceeded} from '../actions/projektstufe-add.actions';
import {archiveProjektFailed, archiveProjektStart, archiveProjektSucceeded} from '../actions/projekt-archive.actions';
import {
  dearchiveProjektFailed,
  dearchiveProjektStart,
  dearchiveProjektSucceeded
} from "../actions/projekt-dearchive.actions";
import {loadUserNodesFailed, loadUserNodesStart, loadUserNodesSucceeded} from "../actions/getUserNodes.actions";
import {pasteProjektFailed, pasteProjektStart, pasteProjektSucceeded} from "../actions/projekt-paste.actions";
import {loadCopyNodesFailed, loadCopyNodesStart, loadCopyNodesSucceeded} from "../actions/getCopyNodes.actions";

export interface ProjektState {
    isLoading: boolean;
    items: ProjektItem[];
    nodes: {
      items: NodeItem[];
    };
    usernodes: {
      items: NodeItem[];
    };
    copyNodes: {
      items: NodeItem[];
    };
}

export const initialState: ProjektState = {
    isLoading: false,
    items: [],
  nodes: {
    items: [],
  },
  usernodes: {
    items: [],
  },
  copyNodes: {
    items: [],
  },
};

const ons = [
    on(loadProjekteStart, (state: ProjektState) => ({ ...state, isLoading: true })),
    on(loadProjekteSucceeded, (state: ProjektState, action) => ({
        ...state,
        isLoading: false,
        items: action.item,
    })),
    on(loadProjekteFailed, (state: ProjektState) => ({ ...state, isLoading: false })),
  on(getFilteredProjektStart, (state: ProjektState) => ({ ...state, isLoading: true })),
  on(getFilteredProjektSucceeded, (state: ProjektState, action) => ({
    ...state,
    isLoading: false,
    nodes: {
      ...state.nodes,
      items: action.item,
    },
  })),
  on(getFilteredProjektFailed, (state: ProjektState) => ({ ...state, isLoading: false })),
  on(loadNodesStart, (state: ProjektState) => ({ ...state, isLoading: true })),
  on(loadNodesSucceeded, (state: ProjektState, action) => ({
    ...state,
    isLoading: false,
    nodes: {
      ...state.nodes,
      items: action.item,
    },
  })),
  on(loadUserNodesFailed, (state: ProjektState) => ({ ...state, isLoading: false })),
  on(loadUserNodesStart, (state: ProjektState) => ({ ...state, isLoading: true })),
  on(loadUserNodesSucceeded, (state: ProjektState, action) => ({
    ...state,
    isLoading: false,
    usernodes: {
      ...state.usernodes,
      items: action.item,
    },
  })),
  on(loadCopyNodesStart, (state: ProjektState) => ({ ...state, isLoading: false })),
  on(loadCopyNodesFailed, (state: ProjektState) => ({ ...state, isLoading: true })),
  on(loadCopyNodesSucceeded, (state: ProjektState, action) => ({
    ...state,
    isLoading: false,
    copyNodes: {
      ...state.copyNodes,
      items: action.item,
    },
  })),
  on(loadNodesFailed, (state: ProjektState) => ({ ...state, isLoading: false })),
  on(addProjektStart, (state: ProjektState) => ({ ...state, isAddingFirma: true })),
  on(addProjektFailed, (state: ProjektState) => ({ ...state, isAddingFirma: false })),
  on(addProjektSucceeded, (state: ProjektState) => ({ ...state, isAddingFirma: false })),
  on(addProjektstufeStart, (state: ProjektState) => ({ ...state, isAddingFirma: true })),
  on(addProjektstufeFailed, (state: ProjektState) => ({ ...state, isAddingFirma: false })),
  on(addProjektstufeSucceeded, (state: ProjektState) => ({ ...state, isAddingFirma: false })),
  on(deleteProjektStart, (state: ProjektState) => ({ ...state, isDeletingProjekt: true })),
  on(deleteProjektFailed, (state: ProjektState) => ({ ...state, isDeletingProjekt: false })),
  on(deleteProjektSucceeded, (state: ProjektState) => ({ ...state, isDeletingProjekt: false })),
  on(archiveProjektStart, (state: ProjektState) => ({ ...state, isDeletingProjekt: true })),
  on(archiveProjektFailed, (state: ProjektState) => ({ ...state, isDeletingProjekt: false })),
  on(archiveProjektSucceeded, (state: ProjektState) => ({ ...state, isDeletingProjekt: false })),
  on(dearchiveProjektStart, (state: ProjektState) => ({ ...state, isDeletingProjekt: true })),
  on(dearchiveProjektFailed, (state: ProjektState) => ({ ...state, isDeletingProjekt: false })),
  on(dearchiveProjektSucceeded, (state: ProjektState) => ({ ...state, isDeletingProjekt: false })),
  on(editProjektStart, (state: ProjektState) => ({ ...state, isEditingProjekt: true })),
  on(editProjektFailed, (state: ProjektState) => ({ ...state, isEditingProjekt: false })),
  on(editProjektSucceeded, (state: ProjektState) => ({ ...state, isEditingProjekt: false })),
  on(pasteProjektStart, (state: ProjektState) => ({ ...state, isEditingProjekt: true })),
  on(pasteProjektSucceeded, (state: ProjektState) => ({ ...state, isEditingProjekt: false })),
  on(pasteProjektFailed, (state: ProjektState) => ({ ...state, isEditingProjekt: false })),
];

export const projektverwaltungReducer = createReducer(initialState, ...ons);
